import React from "react";

function Paper() {
  return (
    <div className="rounded-xl bg-white p-6 md:p-10 shadow-sm border border-gray-100 min-h-[calc(100vh-8rem)]">
      <h2 className="text-2xl font-light text-gray-800 mb-6">Altruist</h2>
      <div className="space-y-4 text-sm text-gray-600 leading-relaxed max-w-3xl">
        <p>
          ALTRUIST is one of the eight projects selected worldwide for the Joint Call
          by the AXA Research Fund and the Intergovernmental Oceanographic Commission
          of UNESCO (IOC-UNESCO) on Coastal Livelihood within the framework of the
          United Nations Ocean Decade <small>[1]</small>
        </p>
        <p>
          ALTRUIST main goal is to improve the reliability and accuracy of real-time
          earthquake and tsunami monitoring and warning through the use of Global
          Navigation Satellite System (GNSS) ground and ionospheric observations.
        </p>
        <p>
          In detail, ALTRUIST leverages the Total Variometric Approach (TVA)
          methodology <small>[2]</small>. GNSS Variometry is based on single time
          differences of suitable linear combinations of GNSS carrier-phase, allowing
          a GNSS receiver to provide valuable real-time information in a standalone
          operative mode. TVA jointly employs VADASE (Variometric Approach for
          Displacement Analysis Stand-alone Engine) <small>[3]</small> and VARION
          (Variometric Approach for Real-Time Ionosphere Observation){" "}
          <small>[4]</small> algorithms.
        </p>
        <ol className="list-decimal ml-5 space-y-1 text-brand-500">
          <li><a href="https://axa-research.org/funded-projects/climate-environment/mitigating-tsunamis-threats-and-destructive-impacts-through-enhanced-navigation-satellite-system" target="_blank" rel="noreferrer" className="hover:underline">Altruist Project</a></li>
          <li><a href="https://www.nature.com/articles/s41598-021-82532-6" target="_blank" rel="noreferrer" className="hover:underline">Ravanelli et al. &quot;GNSS total variometric approach&quot; Scientific Reports 11.1 (2021)</a></li>
          <li><a href="https://agupubs.onlinelibrary.wiley.com/doi/full/10.1029/2010JB007941" target="_blank" rel="noreferrer" className="hover:underline">Colosimo et al. (2011) JGR: Solid Earth, 116(B11)</a></li>
          <li><a href="https://www.nature.com/articles/srep46607" target="_blank" rel="noreferrer" className="hover:underline">Savastano et al. (2017) Scientific Reports, 7(1), 46607</a></li>
        </ol>
      </div>
    </div>
  );
}

export default Paper;
